<template>
  <div :class="['company',mode]">


    <div class="company_item" v-for="item in list_l" v-if="company[item.name]">
      <div class="company_item_l color63">{{item.word}}</div>

      <div class="company_item_r" v-if="company[item.name].length <= max_len">
        {{company[item.name]}}
      </div>

      <div class="company_item_r" v-show="company[item.name].length > max_len">
        <div v-show="item.is_show">
          <span>
            {{company[item.name]}}
          </span>
          <span class="color50" @click="item.is_show = 0">
            收起
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="4" viewBox="0 0 8 4" fill="none">
              <path d="M0.636495 3.84331C0.811515 4.02863 1.09462 4.05059 1.29504 3.90374L1.34331 3.86351L4.16624 1.1975L6.82292 3.85355C7.00316 4.03379 7.28678 4.04766 7.48292 3.89515L7.53003 3.85355C7.71027 3.67331 7.72413 3.38969 7.57162 3.19355L7.53003 3.14645L4.53003 0.146445C4.35341 -0.0301671 4.07669 -0.0475106 3.88044 0.096993L3.83316 0.136492L0.65669 3.13649C0.45593 3.3261 0.446889 3.64255 0.636495 3.84331Z" 
              />
            </svg>
          </span>
        </div>

        <div v-show="!item.is_show">
          <span>
            {{company[item.name].substring(0,max_len)}}...
          </span>
          <span class="color50" @click="item.is_show = 1">
            展开
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="4" viewBox="0 0 8 4" fill="none">
              <path d="M0.636495 0.15669C0.811515 -0.0286266 1.09462 -0.0505857 1.29504 0.0962626L1.34331 0.136495L4.16624 2.8025L6.82292 0.146448C7.00316 -0.0337941 7.28678 -0.0476589 7.48292 0.104854L7.53003 0.146448C7.71027 0.32669 7.72413 0.610305 7.57162 0.806451L7.53003 0.853555L4.53003 3.85355C4.35341 4.03017 4.07669 4.04751 3.88044 3.90301L3.83316 3.86351L0.65669 0.863508C0.45593 0.673902 0.446889 0.357449 0.636495 0.15669Z" 
              />
            </svg>
          </span>
        </div>

      
        
      </div>
    </div>




    <div class="company_link" @click="goDetail(link1)">
      <span class="color63">查看更多公司资料</span>
      <svg v-if="mode == 'light_mode'" xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
        <rect opacity="0.01" width="8" height="12" fill="#D8D8D8"/>
        <path d="M1.36 1.15428L6.64 5.96107L1.36 10.96" stroke="#636363" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>

      <svg v-else xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
        <rect opacity="0.01" width="8" height="12" fill="#D8D8D8"/>
        <path d="M1.35999 1.15428L6.63999 5.96107L1.35999 10.96" stroke="#B7B7B7" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

  </div>
</template>

<script>

export default {
  props:{
    link1:String,
    company:Object,
  },
  data(){
        return{
            max_len:45,
            mode:this.$route.params.mode,//light,dark
            code:this.$route.params.code,//sz000070
            list_l:[
                {
                    "word": "公司名称",
                    "name": "ORG_NAME"
                },
                {
                    "word": "曾用名",
                    "name": "FORMER_NAME"
                },
                {
                    "word": "董事长",
                    "name": "CHAIRMAN"
                },
                {
                    "word": "董秘",
                    "name": "SECRETARY"
                },
                {
                    "word": "主营业务",
                    "name": "MAIN_BUSINESS"
                },
                {
                    "word": "控股股东",
                    "name": "CONTROLLING_SHAREHOLDER"
                },
                {
                    "word": "实际控制人",
                    "name": "ACTUAL_CONTROLLER"
                },
                {
                    "word": "最终控制人",
                    "name": "ACTUAL_CONTROLLER"
                },
                {
                    "word": "上市日期",
                    "name": "LISTING_DATE"
                },
                {
                    "word": "发行价/市盈率",
                    "name": "ISSUE_PRICE_AFTER_ISSUE_PE"
                }
            ]
        }
    },
    created() {
        console.log(this.$route.params);
        let _arr = [];
        _arr = this.list_l.map(item=>{
          item.is_show = 0;
          return item;
        });
        this.list_l = JSON.parse(JSON.stringify(_arr));
    },
    methods:{
        // 跳转详情页
        goDetail(link) {
          //this.$goAppLink('link',`&jump_link=${link}`);

          this.$srH5CallNativeMethodApp('link',{
            jump_link: link,
          })
        },
    }
}

</script>
<style lang="scss" scoped>
  @import "~@/assets/sass/globalapp.scss";
  .company{
    display: flex;
    padding: rem2(10px) rem2(12px);
    flex-direction: column;
    align-items: flex-start;

    .company_item{
      display: flex;
      font-size: rem2(13px);
      width: 100%;
      margin-bottom: rem2(10px);
      line-height: 1.3;
      .company_item_l{
        width: 28%;
       
      }
      .company_item_r{
        width: 72%;
        .color50{
            display: inline-flex;
            align-items: center;
        svg{
          width: rem2(7.176px);
          height: rem2(4px);
          margin-left: rem2(2px);
        }
      }
      }
    }

    .company_link{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      >span{
        font-size: rem2(13px);
      }
      >svg{
        width: rem2(8px);
        height: rem2(12px);
        margin-left: rem2(5px);
      }
    }
  }

</style>